import {APP_INITIALIZER, isDevMode, NgModule} from '@angular/core';
import {BrowserModule} from '@angular/platform-browser';
import {AppRoutingModule} from './app-routing.module';
import {AppComponent} from './app.component';
import {provideAnimationsAsync} from '@angular/platform-browser/animations/async';
import {SharedModule} from "./shared/shared.module";
import {StoreModule} from '@ngrx/store';
import {metaReducers, reducers} from './store';
import {StoreDevtoolsModule} from '@ngrx/store-devtools';
import {effects} from "./store/effects";
import {EffectsModule} from '@ngrx/effects';
import {MAT_DATE_LOCALE} from "@angular/material/core";
import {HTTP_INTERCEPTORS, HttpClient, provideHttpClient, withInterceptorsFromDi} from "@angular/common/http";
import {AuthInterceptor} from "./guards/auth-interceptor";
import {GraphQLModule} from './graphql.module';
import {NgxPermissionsModule, NgxPermissionsService} from "ngx-permissions";
import {PageComponent} from './page/page.component';
import {TranslateLoader, TranslateModule} from "@ngx-translate/core";
import {CONFIGURATION_TOKEN} from "./app.tokens";
import {TranslateHttpLoader} from "@ngx-translate/http-loader";
import {InitTranslationService} from "./services/init-translation.service";
import {UserManagementService} from './services/user-management.service';
import {provideNgxMask} from 'ngx-mask';
import {DatePipe} from "@angular/common";
import {LoadingBarHttpClientModule} from "@ngx-loading-bar/http-client";
import {LoadingBarModule} from "@ngx-loading-bar/core";
import {LoginComponent} from "./guest/login/login.component";
import {ForgotPasswordComponent} from "./guest/forgot-password/forgot-password.component";
import {CheckYourEmailComponent} from "./guest/check-your-email/check-your-email.component";
import {ResetPasswordComponent} from "./guest/reset-password/reset-password.component";
import {SetPasswordComponent} from "./guest/set-password/set-password.component";
import {FormsModule} from "@angular/forms";
import {ChangePasswordComponent} from "./guest/change-password/change-password.component";
import {BrowserAnimationsModule} from "@angular/platform-browser/animations";
import {CustomTranslateLoader} from "./services/custom-translate-loader";
import {Apollo} from "apollo-angular";
import {GuestMainPageComponent} from './guest/guest-page/guest-main-page/guest-main-page.component';
import {GuestTopBarComponent} from "./guest/guest-page/guest-top-bar/guest-top-bar.component";
import {
  GuestPolicyRegulationsComponent
} from "./guest/guest-page/guest-policy-regulations/guest-policy-regulations.component";
import {GuestFaqComponent} from "./guest/guest-page/guest-faq/guest-faq.component";
import {GuestAwarenessComponent} from "./guest/guest-page/guest-awareness/guest-awareness.component";
import {GuestFooterComponent} from "./guest/guest-page/guest-footer/guest-footer.component";
import {JoditAngularModule} from "jodit-angular";
import {UserProfileComponent} from "./guest/user-profile/user-profile.component";


export function HttpLoaderFactory(http: HttpClient) {
  return new TranslateHttpLoader(http);
}

@NgModule({
  declarations: [
    AppComponent,
    PageComponent,
    LoginComponent,
    ForgotPasswordComponent,
    CheckYourEmailComponent,
    ResetPasswordComponent,
    SetPasswordComponent,
    ChangePasswordComponent,
    GuestMainPageComponent,
    UserProfileComponent,
    GuestTopBarComponent,
    GuestPolicyRegulationsComponent,
    GuestFaqComponent,
    GuestAwarenessComponent,
    GuestFooterComponent,
  ],
  imports: [
    BrowserModule,
    BrowserAnimationsModule,
    AppRoutingModule,
    LoadingBarHttpClientModule,
    LoadingBarModule,
    SharedModule,
    JoditAngularModule,
    StoreModule.forRoot(reducers, {
      metaReducers,
      runtimeChecks: {
        strictStateSerializability: false,
        strictActionSerializability: false,
        strictStateImmutability: true,
        strictActionImmutability: true,
        strictActionWithinNgZone: true,
        strictActionTypeUniqueness: true,
      }
    }),
    StoreDevtoolsModule.instrument({
      maxAge: 25,
      logOnly: !isDevMode(),
      autoPause: true,
      trace: false,
      traceLimit: 75,
    }),
    EffectsModule.forRoot(effects),
    GraphQLModule,
    NgxPermissionsModule.forRoot(),
    TranslateModule.forRoot({
      loader: {
        provide: TranslateLoader,
        useClass: CustomTranslateLoader,
        deps: [Apollo]
      }
    }),
    FormsModule
  ],
  providers: [
    DatePipe,
    provideAnimationsAsync(),
    provideNgxMask(),
    {
      provide: HTTP_INTERCEPTORS,
      useClass: AuthInterceptor,
      multi: true,
    },
    {
      provide: CONFIGURATION_TOKEN,
      useValue: 'to be used later for translation storage and use translation on components',
      multi: true
    },
    // { provide: RouterStateSerializer, useClass: CustomSerializer },
    {provide: MAT_DATE_LOCALE, useValue: 'en-GB'},
    NgxPermissionsService,
    {
      provide: APP_INITIALIZER,
      useFactory: (uaaService: UserManagementService, initTranslationService: InitTranslationService) => {
        return (async () => {
          // await initTranslationService.initTranslations();
          await uaaService.authRole();
        });
      },
      deps: [UserManagementService, InitTranslationService],
      multi: true
    },
    provideHttpClient(withInterceptorsFromDi())
  ],
  bootstrap: [AppComponent]
})
export class AppModule {
}
